import styled from 'styled-components';

export const GalleryWrapper = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 6px;

  img {
    max-width: calc(100vw - 24px);
    object-fit: cover;
  }

  @media ${({ theme }) => theme.media.desktop} {
    flex-direction: row;

    img {
      max-width: calc(50% - 8px);
    }
  }
`;
